import React__default from 'react';
import PropTypes from 'prop-types';
import { S as SvgVehicleGradeBronzeIcon } from './vehicle-grade-bronze-icon-fa0d2f90.js';
import { S as SvgVehicleGradeGoldIcon } from './vehicle-grade-gold-icon-cd6a5f27.js';
import { S as SvgVehicleGradeSilverIcon } from './vehicle-grade-silver-icon-2d1df0bd.js';

const VehicleGrades = {
  BRONZE: 'bronze',
  GOLD: 'gold',
  SILVER: 'silver'
};
const {
  BRONZE,
  GOLD,
  SILVER
} = VehicleGrades;
const VehicleGradeRankOrder = [BRONZE, SILVER, GOLD];
const VehicleGradeIcons = Object.freeze({
  [BRONZE]: /*#__PURE__*/React__default.createElement(SvgVehicleGradeBronzeIcon, null),
  [GOLD]: /*#__PURE__*/React__default.createElement(SvgVehicleGradeGoldIcon, null),
  [SILVER]: /*#__PURE__*/React__default.createElement(SvgVehicleGradeSilverIcon, null)
});
const VehicleGradeIcon = ({
  grade
}) => VehicleGradeIcons[grade];
VehicleGradeIcon.propTypes = {
  grade: PropTypes.oneOf(Object.values(VehicleGrades))
};

export { VehicleGradeIcons, VehicleGradeRankOrder, VehicleGrades, VehicleGradeIcon as default };
